module.exports = __webpack_public_path__ + "img/textLogoHeaderICFA.0de7889.png";